import { Power0, TweenMax } from "gsap";
import { Help, HelpPanelColor, HelpParameters } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FGPickElemState, FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { SlotGameType1 } from "../SlotGameType1";


// namespace SlotGames {
	export class BambooSecrets extends SlotGameType1 
	{

		////protected override freegameBonusFactory: FreegameBonusFactory = new BambooSecretsFreegameBonusFactory();
		
		protected override pickBonusFactory:PickBonusFactory = new PandaPickBonusFactory();
		//protected panelFactory:IPanelFactory = new BambooSecretsPanelFactory();
		protected override helpFactory:IHelpFactory = new BambooSecretsHelpFactory();
		//LED COLOR
		protected override ColorLed:string="57,255,20\n";
	

		//SEND COLOR FOR RSA 
        protected override color: RewardColor = 
        {
            color: "#96DB2A",
		    coloroutherStroke: "black",
            colorinnerStroke: "#DB3814",
        }
        
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "BambooSecrets");

			
			this.spinnableReelsParams.topBorderWidth = 7;
			this.spinnableReelsParams.bottomBorderWidth = 7;
		}
	}

	// class BambooSecretsFreegame extends FreegameBonus
	// {
	// 	protected rockcontainer: HTMLElement[]=[];
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 7;
	// 		this.spinnableReelsParams.bottomBorderWidth = 7;
	// 	}
		
	// 	// 	protected BackgroundPrepare(resourceManager: IWriteOnlyResourceManager)
	// 	// {
	// 	// 	resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.jpg", this.resid.ScopedResourceName(["background", "image"])));
	// 	// 	//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background.2", "image"])));
	// 	// 	//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.3.jpg", this.resid.ScopedResourceName(["background.3", "image"])));
	// 	// }
	// 	protected override BackgroundPrepare(resourceManager: IWriteOnlyResourceManager)
	// 	{
	// 		super.BackgroundPrepare(resourceManager);
	// 		this.RockPrepare(resourceManager);
	// 	}
	// 	protected RockPrepare(resourceManager: IWriteOnlyResourceManager)
	// 	{
	// 		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "rock.png", this.resid.ScopedResourceName(["rock", "image"])));
	// 		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background.2", "image"])));
	// 		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.3.jpg", this.resid.ScopedResourceName(["background.3", "image"])));
	// 	}
	
		

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			// Log.Debug(this.logGroup, "Picked index " + index);
	
	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});
	
	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					TweenMax.fromTo(this.rockcontainer[i], 1,{scale:1,y:0}, {y:45,scale: 1.1, ease: Power0.easeNone, paused: false,onComplete: () =>
	// 						TweenMax.to(this.rockcontainer[i],0.5,{scale:1,y:0,delay:10})
	// 					});
	// 					this.picks[i].awardElem.style.fontSize = "100px";
	// 					this.picks[i].awardElem.style.left = "79px";
	// 					this.picks[i].awardElem.style.top = "24px";
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 					TweenMax.fromTo(this.rockcontainer[i], 1,{scale:1,y:0}, {y:-70,scale: 0.70, ease: Power0.easeNone, paused: false,onComplete: () =>
	// 						TweenMax.to(this.rockcontainer[i],0.5,{scale:1,y:0,delay:10})
	// 						});
	// 					this.picks[i].awardElem.style.fontSize = "50px";
	// 					this.picks[i].awardElem.style.left = "79px";
	// 					this.picks[i].awardElem.style.top = "24px";
	// 				}
	// 			}
	
	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}
	

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void 
	// 	{
	// 		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "go3v2.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	// 	}
	// 	protected containerRocks:HTMLElement = null;

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
	// 	{
			
			
	// 		this.containerRocks = document.createElement("div");
	// 		this.containerRocks.classList.add("RocksContainer");
	// 		this.containerRocks.style.width = "1920px";
	// 		this.containerRocks.style.height = "1080px";
	// 		this.containerRocks.style.position = "absolute";
	// 		this.containerRocks.style.left = "0px";
	// 		this.containerRocks.style.top = "0px";

			
	// 		// align award to be in the box, when box opens
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 654 * 0.75;
	// 		let displayHeight: number = 371 * 0.75;

	// 		let displayRects: PixelRect[] = 
	// 		[
	// 			new PixelRect(-30, 351, displayWidth, displayHeight),
	// 			new PixelRect(350, 495, displayWidth, displayHeight),
	// 			new PixelRect(750, 351, displayWidth, displayHeight),
	// 			new PixelRect(1093, 495, displayWidth, displayHeight),
	// 			new PixelRect(1433, 351, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(79, 24, displayWidth - 143, displayHeight - 48);
			
	// 		//let awardRect = new PixelRect(0, 0, displayWidth, displayHeight);
			
	// 		for (let i = 0; i < displayRects.length; i++) 
	// 		{
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect));
	// 			this.rockcontainer[i] = document.createElement("div");
	// 			this.rockcontainer[i].classList.add("rockbase" + i);
	// 			this.rockcontainer[i].style.width = displayWidth.toString()+"px";
	// 			this.rockcontainer[i].style.height = displayHeight.toString() + "px";
	// 			this.rockcontainer[i].style.left = displayRects[i].x.toString() + "px";
	// 			this.rockcontainer[i].style.top = (displayHeight - 35) + displayRects[i].y + "px";
	// 			this.rockcontainer[i].style.backgroundRepeat = "no-repeat";
	// 			this.rockcontainer[i].style.backgroundPosition = "center";
	// 			this.rockcontainer[i].style.position = "absolute";

	// 			this.containerRocks.appendChild(this.rockcontainer[i]);

	// 		}
			
	// 		return geometry;
	// 	}

	// 	//CREATE FOR ROTATE ONLY THE PICK ELEMENT
	// 	protected override PicksLoaded(resourceManager: IReadOnlyResourceManager): void {

	// 		let pickGeometries: FreegamePickElemGeometry[] = this.PicksPositions();
	// 		this.canvasSprite = null;
	// 		this.picksContainer.appendChild(this.containerRocks);
	
	// 		for (let i = 0; i < pickGeometries.length; i++) {
	
	// 			let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("pick")).sprite.Copy();
	// 			//let canvasSprite: CanvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	// 			this.canvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	
	// 			let params: FreegamePickElementParams = new FreegamePickElementParams(
	// 				i, 
	// 				this.logGroup,
	// 				pickGeometries[i].displayRect, 
	// 				pickGeometries[i].pickRect, 
	// 				pickGeometries[i].awardRect, 
	// 				this.canvasSprite
	// 			);

				
	// 			this.rockcontainer[i].style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["rock", "image"])).CssBackground();

					
	// 			let pick: FreegamePickElement = this.params.pickElementFactory.CreatePickElement(params);
	// 			//ROTATE PICK FOR FILL IMG
	// 			//pick.pickElem.style.transform="rotate(45deg)";
	// 			pick.AddPickCallback((index: number) => this.OnPicked(index));
	// 			pick.AddFreegamePickAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
	// 			pick.AddRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));
	
	// 			pick.OnDisplayAwardCallback = () => this.audio.Play(this.resid.ScopedResourceName("pick"));
	// 			pick.OnDisplayRemainingCallback = () => this.audio.Replay(this.resid.ScopedResourceName("remaining"));
	
				
	// 			this.picks.push(pick);
	// 			this.picksContainer.appendChild(pick.View());
				
	// 		}
	// 	}
		

	// 	protected PrepareMessage(resourceManager: ResourceManager)
	// 	{
	// 		// super.PrepareMessage(resourceManager);

	// 		// //override dialog box message color
	// 		// this.introMessageContainer.style.color = "yellow";

	// 		//this.pickElem.innerHTML = "BAMBO";
	// 	}
	// }





	// then you make this class but change the name for evey game
	class PandaPickBonus extends PickBonus
	{
	}

	class PandaPickBonusElement extends PickBonusElement
	{
	}
	


	class BambooSecretsFreegamePickElement extends FreegamePickElement
	{
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			this.awardElem.style.left = "79px";
			this.awardElem.style.top = "24px";
			this.awardElem.style.fontSize ="150px";
			
		}

		protected override PreparePickedElement(): void
		{
			this.awardElem.style.color = "yellow";
			this.awardElem.style.fontSize = "150px";
			this.awardElem.style.fontWeight="bold";
		}

		protected override PrepareRemainingElement(): void
		{
			this.awardElem.style.removeProperty("color");
			this.awardElem.style.removeProperty("fontSize");
		}
		protected override AnimPrepare(): void {
			super.AnimPrepare();
			this.WaitPickAnimPrepare();
	
			this.anim_bringfront = TweenMax.to(this, 1, {myscale: 1, ease: Power0.easeNone, paused: true, onComplete: () => this.stateMachine.ChangeState(FGPickElemState.WaitDisplayAward)});
			this.anim_pushback = TweenMax.to(this, 1, {myscale: 0.65, ease: Power0.easeNone, paused: true, onComplete: () => this.stateMachine.ChangeState(FGPickElemState.WaitDisplayRemainig)});
		}
	
		protected override WaitPickAnimPrepare(): void {
			super.WaitPickAnimPrepare();
			this.anim_waitpick = TweenMax.fromTo(this, 1, {myscale: 0.8}, {myscale: 0.85, yoyo: true, repeat: -1, ease: Power0.easeNone, paused: true});
		}
	}

	//Panel Colorized
	class BambooSecretsPanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new BambooSecretsPanel(params);
		}
	}

	class BambooSecretsPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors ={
				backgroundButtonColor: "linear-gradient(rgb(14, 38, 8),rgb(42, 89, 21), rgb(68, 140, 35),rgb(42, 89, 21),rgb(14, 38, 8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, yellowgreen,transparent ) 0 10 100%",
			};
			return color;
			
		}

	}


	//Help Colorized
	class  BambooSecretsHelpFactory implements IHelpFactory
	{
		public CreateNewHelp(params: HelpParameters):Help
		{
			return new  BambooSecretsHelp(params);
		}
	}

	class  BambooSecretsHelp extends Help
	{
		protected override BackgroundPanel():HelpPanelColor
		{
			let color:HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(14, 38, 8),rgb(42, 89, 21), rgb(68, 140, 35),rgb(42, 89, 21),rgb(14, 38, 8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			};

			return color;
		}
	}





	// class BambooSecretsFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
	// 	{
	// 		return new BambooSecretsFreegame(gameName, params);
	// 	}
		
		
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new BambooSecretsFreegamePickElement(params);
	// 	}
		
	// }

	class PandaPickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new PandaPickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new PandaPickBonusElement(params);
		}
		
	}
// }
